export function fmtDbm(v: number | null | undefined): string {
  if (v === null || v === undefined || Number.isNaN(v)) return "—";
  return `${v.toFixed(2)} dBm`;
}

// ITU-T G.984 defaults: -27 sensitivity, -8 overload. The two lower bands are
// the operator's call -- on a plant with long drops, -24 paints nearly half
// the ONTs amber -- so they come from the alert rules (see useSignalBands).
export type SignalLevel = "good" | "warn" | "crit" | "unknown";

export type SignalBands = { warn: number; crit: number };
export const DEFAULT_BANDS: SignalBands = { warn: -24, crit: -27 };

/** Overload is a device limit, not a policy: it stays fixed. */
const OVERLOAD_DBM = -8;

export function classifyRx(rx: number | null | undefined, bands: SignalBands = DEFAULT_BANDS): SignalLevel {
  if (rx === null || rx === undefined || Number.isNaN(rx)) return "unknown";
  if (rx < bands.crit || rx > OVERLOAD_DBM) return "crit";
  if (rx < bands.warn) return "warn";
  return "good";
}

export const signalColor: Record<SignalLevel, string> = {
  good: "text-signal-good",
  warn: "text-signal-warn",
  crit: "text-signal-crit",
  unknown: "text-signal-unknown",
};